export default {
  towStoreDialog: {
    title: 'Despacho de Tow Store',
    description: 'Veo que está despachando una Tow Store (TS). Por favor, agregue la dirección del lote del proveedor.',
    addressLabel: 'Dirección',
    addressPlaceholder: 'Ingrese la dirección del lote del proveedor',
    phoneLabel: 'Número de Teléfono del Proveedor',
    phonePlaceholder: '(555) 123-4567',
    submit: 'Enviar',
    closeAriaLabel: 'cerrar',
    addressNotFound: 'No pudimos encontrar una dirección de Google para el proveedor seleccionado. Es posible que deba ingresarla manualmente.'
  }
};
